/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListModelConfigVersionsPathParams = NonNullable<
  operations['listModelConfigVersions']['parameters']['path']
>;

export type ListModelConfigVersionsQueryParams = NonNullable<
  operations['listModelConfigVersions']['parameters']['query']
>;

export interface Input extends ListModelConfigVersionsPathParams {
  apiVersion?: string;
  query?: ListModelConfigVersionsQueryParams;
}

export async function listModelConfigVersions(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/ai-configs/model-configs/{modelConfigKey}/versions', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
